import { ThemeType } from '@/v1/main/domain/config';
import { useTheme } from '@/v1/main/views/Provider';

import styles from './Image.module.scss';

interface Props {
    themeType?: ThemeType;
}

export const LogoImage = ({ themeType }: Props) => {
    const { theme } = useTheme();
    const classes = [styles.logo];
    const mode = themeType ?? theme;
    if (mode == ThemeType.DARK) {
        classes.push(styles.dark);
    } else {
        classes.push(styles.light);
    }
    return (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
            <span className={classes.join(' ')} />
        </div>
    );
};
